// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const AdminOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [updateStatus, setUpdateStatus] = useState("");

//   // Fetch orders
//   const fetchOrders = async () => {
//     try {
//       const response = await axios.get("http://localhost:5000/api/orders");
//       setOrders(response.data);
//       setLoading(false);
//     } catch (err) {
//       setError("Failed to fetch orders. Please try again later.");
//       setLoading(false);
//     }
//   };

//   // Update delivery status
//   const updateDeliveryStatus = async (orderId, status) => {
//     try {
//       const response = await axios.put(
//         `http://localhost:5000/api/orders/${orderId}/delivery-status`,
//         { deliveryStatus: status }
//       );
//       setUpdateStatus(`Order ${orderId} updated to ${status}.`);
//       // Update the local state
//       setOrders((prevOrders) =>
//         prevOrders.map((order) =>
//           order.orderId === orderId ? { ...order, deliveryStatus: status } : order
//         )
//       );
//     } catch (err) {
//       setError(`Failed to update order ${orderId}.`);
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   if (loading) return <div>Loading orders...</div>;
//   if (error) return <div>{error}</div>;

//   return (
//     <div>
//       <h1>Admin Orders</h1>
//       {updateStatus && <p style={{ color: "green" }}>{updateStatus}</p>}
//       {orders.map((order) => (
//         <div key={order.orderId} style={{ border: "1px solid #ddd", padding: "10px", margin: "10px 0" }}>
//           <h3>Order ID: {order.orderId}</h3>
//           <p><strong>Customer:</strong> {order.customerDetails.firstName} {order.customerDetails.lastName}</p>
//           <p><strong>Total Amount:</strong> ₹{order.paymentDetails.totalAmount}</p>
//           <p><strong>Delivery Status:</strong> {order.deliveryStatus}</p>
//           <select
//             value={order.deliveryStatus}
//             onChange={(e) => updateDeliveryStatus(order.orderId, e.target.value)}
//           >
//             <option value="pending">Pending</option>
//             <option value="shipped">Shipped</option>
//             <option value="delivered">Delivered</option>
//             <option value="cancelled">Cancelled</option>
//           </select>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default AdminOrders;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import "./Adminorder.css"
// import LeftSideNavaBarAdmin from "./LeftSideNavaBarAdmin";
// const AdminOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // Fetch orders
//   const fetchOrders = async () => {
//     try {
//       const response = await axios.get("/api/orders");
//       setOrders(response.data.map((order) => ({ ...order, notification: null, updatedAt: new Date() })));
//       setLoading(false);
//     } catch (err) {
//       setError("Failed to fetch orders. Please try again later.");
//       setLoading(false);
//     }
//   };

//   // Update delivery status
//   const updateDeliveryStatus = async (orderId, status) => {
//     try {
//       const response = await axios.put(`/api/orders/${orderId}/delivery-status`, {
//         deliveryStatus: status,
//       });
//       const updatedOrder = response.data;

//       setOrders((prevOrders) =>
//         prevOrders.map((order) =>
//           order.orderId === orderId
//             ? {
//               ...order,
//               deliveryStatus: status,
//               notification: `Updated to '${status}' on ${new Date().toLocaleString()}`,
//               updatedAt: new Date(),
//             }
//             : order
//         )
//       );
//     } catch (err) {
//       setOrders((prevOrders) =>
//         prevOrders.map((order) =>
//           order.orderId === orderId
//             ? { ...order, notification: "Failed to update. Please try again.", updatedAt: new Date() }
//             : order
//         )
//       );
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   if (loading) return <div className="container">Loading orders...</div>;
//   if (error) return <div className="container errorText">{error}</div>;

//   return (
//     <div>
//       <div className="breadcrumb-wrap bg-f br-2">
//       </div>
      
//       <div className="containerorder">
//       <div className="row ">
//           <div class="col-xl-2 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
//             <LeftSideNavaBarAdmin /></div>
//         <div className="col-xl-10 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
//         <table className="ordertable">
//           <thead>
//             <th>Order ID</th>
//             <th>Customer Name</th>
//             <th>Customer ID</th>
//             <th>Total Amount</th>
//             <th>Delivery Status</th>
//             <th>Status Update</th>
//           </thead>
//           <tbody>
//             {orders.map((order) => (
//               <tr>
//                 <td data-label="Order ID">{order.orderId}</td>
//                 <td data-label="Customer Name">{order.customerDetails.billingAddress.fullName}</td>
//                 <td data-label="Customer ID">{order.customerId}</td>
//                 <td data-label="Total Amount">₹{order.paymentDetails.totalAmount}</td>
//                 <td data-label="Delivery Status">{order.deliveryStatus}</td>
//                 <td data-label="Status Update">            <select
//                   className="select"
//                   value={order.deliveryStatus}
//                   onChange={(e) => updateDeliveryStatus(order.orderId, e.target.value)}
//                 >
//                   <option value="pending">Pending</option>
//                   <option value="Processing">Processing</option>
//                   <option value="shipped">Shipped</option>
//                   <option value="delivered">Delivered</option>
//                   <option value="cancelled">Cancelled</option>
//                 </select></td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//         </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminOrders;

import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./Adminorder.css";
import LeftSideNavaBarAdmin from "./LeftSideNavaBarAdmin";
import AdminTopNavbar from "./AdminTopNavbar";

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null); // State for selected order

  
 // Fetch orders
const fetchOrders = async () => {
  try {
    const response = await axios.get("/api/orders");

    // Sort orders by orderDate (latest first)
    const sortedOrders = response.data.sort(
      (a, b) => new Date(b.orderDate) - new Date(a.orderDate)
    );

    setOrders(sortedOrders);
    setLoading(false);
  } catch (err) {
    setError("Failed to fetch orders. Please try again later.");
    setLoading(false);
  }
};


  // Update delivery status
  const updateDeliveryStatus = async (orderId, status) => {
    try {
      await axios.put(`/api/orders/${orderId}/delivery-status`, { deliveryStatus: status });

      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.orderId === orderId ? { ...order, deliveryStatus: status } : order
        )
      );
    } catch (err) {
      alert("Failed to update status. Please try again.");
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  if (loading) return <div className="container">Loading orders...</div>;
  if (error) return <div className="container errorText">{error}</div>;

  return (
    <div>
     <AdminTopNavbar/>
      <div className="containerorder"  style={{ paddingTop: '250px' }}>
        <div className="row">
          
          <div className="col-12">
            <table className="ordertable">
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Customer Name</th>
                  <th>Total Amount</th>
                  <th>Delivery Status</th>
                  <th>Status Update</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order) => (
                  <tr key={order.orderId}>
                    <td data-label="Order ID">{order.orderId}</td>
                    <td data-label="Customer Name">{order.customerDetails?.billingAddress?.fullName || "N/A"}</td>
                    <td data-label="Total Amount">₹{order.paymentDetails.totalAmount}</td>
                    <td data-label="Delivery Status">{order.deliveryStatus}</td>
                    <td data-label="Status">
                      <select
                        className="select"
                        value={order.deliveryStatus}
                        onChange={(e) => updateDeliveryStatus(order.orderId, e.target.value)}
                      >
                       <option value="Select">Select</option>
                        {/* <option value="pending">Pending</option>
                        <option value="Processing">Processing</option>
                        <option value="shipped">Shipped</option>
                        <option value="delivered">Delivered</option> */}
                        <option value="cancelled">Cancelled</option>
                      </select>
                    </td>
                    <td>
                      <button className="view-btn" onClick={() => setSelectedOrder(order)}>
                        View More
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Order Details Modal */}
      {selectedOrder && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Order Details</h2>
            <div className="d-flex vmod">
            <p><strong>Order ID:</strong> {selectedOrder.orderId}</p>
            <p><strong>Order Date:</strong> {new Date(selectedOrder.orderDate).toLocaleString()}</p>
            <p><strong>Total Amount:</strong> ₹{selectedOrder.paymentDetails.totalAmount}</p>
                
            <p><strong>Payment Status:</strong> {selectedOrder.paymentDetails.status}</p>
            <p><strong>Gstin Number</strong> {selectedOrder.paymentDetails.gstNumber}</p>
            <p><strong>order Status:</strong> {selectedOrder.orderStatus}</p>
            <p><strong>Delivery Status:</strong> {selectedOrder.deliveryStatus}</p>
            </div><hr/>
            <div className="d-flex">
            <div className="vmcd">
            <h3>Customer Details</h3>
            <p><strong>Name:</strong> {selectedOrder.customerDetails.billingAddress.fullName}</p>
            <p><strong>Email:</strong> {selectedOrder.customerDetails.billingAddress.email}</p>
            <p><strong>Phone:</strong> {selectedOrder.customerDetails.billingAddress.phoneNumber}</p>
            <p><strong>Address:</strong> {`${selectedOrder.customerDetails.billingAddress.addressLine1}, ${selectedOrder.customerDetails.billingAddress.addressLine2},`}<br/>{` ${selectedOrder.customerDetails.billingAddress.city}, ${selectedOrder.customerDetails.billingAddress.state},`}<br/>{` ${selectedOrder.customerDetails.billingAddress.pinCode}, ${selectedOrder.customerDetails.billingAddress.country}`}</p>
            </div>
            <hr/>
            <div>
            <h3>Products</h3>
            <ul className="orderproductlist">
              {selectedOrder.products.map((product) => (
                <li key={product.productId} className="orderproductcard">
                  <div>
                  <p><strong>Product Name:</strong> {product.productName}</p>
                  <p><strong>Quantity:</strong> {product.quantity}</p>
                  <p><strong>Size:</strong> {product.size}</p>
                  <p><strong>Price:</strong> ₹{product.price}</p></div>
                  <img src={`${product.image}`} style={{height:"20vh"}}/>
                </li>
              ))}
            </ul>
            </div>
            </div>
            <button className="close-btn1" onClick={() => setSelectedOrder(null)}>X</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminOrders;
 